import { takeEvery } from 'redux-saga/effects';
import { signalingRoomReactionsReceived } from 'features/room-reactions/actions';
import { onRoomReactionsReceivedSaga } from 'features/room-reactions/sagas/onRoomReactionsReceivedSaga';

export default function* roomReactionsWatcher() {
  yield takeEvery(signalingRoomReactionsReceived, onRoomReactionsReceivedSaga);
}
